import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import {ScreenFormatContext} from "@mnjsplatform/data";
import i18next from "i18next";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";
import YearBonusDetail from "./YearBonusDetail";
import SMSAuthenticator from "../security/SMSAuthenticator";

class YearBonus extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false,
            currentRowKey: null,
            viewMethod: '',
            isAccess: false,
            accessMessage: ''
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        let isAccess = false;
        let accessMessage = '';
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.SalaryChangeData_POx_Ybd_CheckAccess.execute({IsRaisError: 0}, {withParams: true}));
                isAccess = this.props.SalaryChangeData_POx_Ybd_CheckAccess_Params.getField(0, 'IsAccess') === 1;
                accessMessage = this.props.SalaryChangeData_POx_Ybd_CheckAccess_Params.getField(0, 'RaisErrorMess');
                await this.props.dispatch(this.props.dataItem_Periods.execute());
                await this.changeYear(0);
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true, isAccess: isAccess, accessMessage: accessMessage})
        }
    }

    renderParam = (h) => {
        return (
            <div>
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-3">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        );
    }

    changeYear = async (selectedIndex) => {
        if (selectedIndex < 0)
            return;
        const row = this.props.dataItem_Periods.getRow(selectedIndex);
        this.setState({
            viewMethod: row.ViewMethod,
            currentYear: Number.parseInt(row.BonusYear),
            currentRowKey: {SalaryChangeIntId: row.SalaryChangeIntId, IsJoin: row.ViewIsJoin}
        });
    }

    render() {
        return (
            <ScreenFormatContext.Consumer>
                {isDesktop => {
                    return (
                        <div id="YearBonusDetailReportHolder">
                            <PlaceholderWrapper placeholderId="10"
                                                title={<><i
                                                    className='fa fa-info'/>&nbsp;{i18next.t('YearBonus_1')}</>}
                                                showInstruction={false}
                                                canCollapse={false}>
                                {this.state.isDataReady
                                    ?
                                    this.state.isAccess
                                        ? <SMSAuthenticator>
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <MnComboStandalone
                                                        ownItem={this.props.dataItem_Periods}
                                                        style={{cursor: 'pointer'}}
                                                        valueFieldName="BonusYear"
                                                        withSearch={false} onSelected={this.changeYear}/>
                                                </div>
                                            </div>
                                            <br/>
                                            {this.state.viewMethod && this.state.currentRowKey &&
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <YearBonusDetail viewMethod={this.state.viewMethod}
                                                                         rowKey={this.state.currentRowKey}
                                                                         currentYear={this.state.currentYear}/>
                                                    </div>
                                                </div>
                                            }
                                        </SMSAuthenticator>
                                        : <div className="row">
                                            <div className="col-md-12">
                                                <div className="alert alert-danger" role="alert">
                                                    {this.state.accessMessage}
                                                </div>
                                            </div>
                                        </div>
                                    : i18next.t('LoadingLabel')
                                }
                            </PlaceholderWrapper>
                        </div>
                    );
                }}
            </ScreenFormatContext.Consumer>
        );
    }
}

YearBonus.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Periods: PropTypes.object,
    SalaryChangeData_POx_Ybd_CheckAccess: PropTypes.object,
    SalaryChangeData_POx_Ybd_CheckAccess_Params: PropTypes.object
}

YearBonus.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Periods: state.yearBonusState.SalaryChangeData_POx_Ybd_Periods,
        //Y!!! dataItem_Periods: state.yearBonusState.TestTable_POx_Ybd_Periods,
        SalaryChangeData_POx_Ybd_CheckAccess: state.yearBonusState.SalaryChangeData_POx_Ybd_CheckAccess,
        SalaryChangeData_POx_Ybd_CheckAccess_Params: state.yearBonusState.SalaryChangeData_POx_Ybd_CheckAccess_Params
    }
}

export default connect(mapStateToProps)(YearBonus);